import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import Testimonials from "@/components/site/Testimonials";
import Careers from "@/components/site/Careers";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <Services />
      <Testimonials />
      <Careers />
      <Contact />
      <Footer />
    </main>
  );
}
